/**
 * The FTUE v2 gate: PostHog flag `ftue-v2`, or a `?ftue=v2` URL override
 * (remembered for the tab) so any PR preview can try it with any account.
 * `?ftue=off` clears the override.
 */
export const FTUE_V2_FLAG = 'ftue-v2';
/** The app's own experiment (2026-10-22: separate from web — baselines,
 *  start dates and old builds differ). Version-gated by the flag's release
 *  conditions in PostHog. */
export const FTUE_V2_APP_FLAG = 'ftue-v2-app';

/**
 * Whether a flag value puts this user in the guided first session (both
 * clients). The flags run as PostHog experiments, `control` / `test`, and
 * `control` is a truthy string: a truthiness read (posthog's
 * `isFeatureEnabled` / `useFeatureFlagEnabled`) gives BOTH arms the guided
 * session. Only `test` (or `true`, a plain rollout) is on. `null` while the
 * flags haven't loaded: unassigned, the classic flow, never "control".
 */
export function ftueV2ArmFromFlag(value: unknown): boolean | null {
  if (value === undefined || value === null) return null;
  return value === true || value === 'test';
}

export const FTUE_URL_PARAM = 'ftue';
export const FTUE_URL_ON = 'v2';
export const FTUE_URL_OFF = 'off';

/** The override a URL search string carries: true / false / null (none). */
export function ftueUrlOverride(search: string): boolean | null {
  const value = new URLSearchParams(search).get(FTUE_URL_PARAM);
  if (value === FTUE_URL_ON) return true;
  if (value === FTUE_URL_OFF) return false;
  return null;
}
